// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dots[data-v-79177ec1]{position:absolute;width:10px;height:10px;background-image:radial-gradient(currentColor 22%,transparent 23%),radial-gradient(currentColor 22%,transparent 23%);background-size:9px 9px;background-position:0 0,0 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
